import styled from 'styled-components'

export const HeaderActions = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))
